import { useEffect } from 'react';
import { apiFetch } from './api-client';
import { API_BASE } from './api-base';

/**
 * `APP_OPEN`, once per page session (docs/smart-notifications-design.md §5.7) — web's twin of the
 * report the phones make on every connect. It stamps `attention_state.last_app_open_at`, which is what
 * lets the ledger tell "engaged, just not in a chat" from "gone".
 *
 * Mounted beside `usePresenceReporter` in `AppFrame`, and like it best-effort: the fetch is
 * fire-and-forget and every failure is swallowed. A module-level latch (not a ref) makes it once per
 * PAGE SESSION even if the frame remounts — a remount is not the person coming back.
 */
let reported = false;

export function useAppOpenSignal(): void {
  useEffect(() => {
    if (typeof window === 'undefined' || reported) return;
    reported = true;
    apiFetch(`${API_BASE}/api/client-signal`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ kind: 'appOpen' }),
      keepalive: true,
    }).catch(() => {});
  }, []);
}

export function resetAppOpenSignalForTests(): void {
  reported = false;
}
